import { Portal as PortalPrimitive } from 'radix-ui';
export const Portal = PortalPrimitive.Root;
export const Root = PortalPrimitive.Root;
export type PortalProps = PortalPrimitive.PortalProps;
